module.exports = __webpack_public_path__ + "static/img/project_logo_adamlobo.bb108a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_logo_adamlobo.svg
// module id = 747
// module chunks = 1